import { LOGIN_SUCCESS, LOGIN_FAILED, LOGOUT } from "./constants";
import { JWT } from "../../../shared";
import { AuthService } from "../../../services";

export const login = (data) => async (dispatch) => {
  try {
    const response = await AuthService.Login(data);
    if (response?.isSuccess) {
      const user = {
        id: response?.data?.userID,
        firstName: response?.data?.firstName,
        lastName: response?.data?.lastName,
        email: response?.data?.email,
        role: response?.data?.userType,
        profileUrl: response?.data?.profileUrl,
      };
      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          access_token: response?.data?.tokens?.access_token,
          user: user,
        },
      });

      JWT.setJwt(response?.data?.tokens?.accessToken);
      JWT.setRefreshJwt(response?.data?.tokens?.refreshToken?.tokenString);
      AuthService.setLoginUser(user);

      return response;
    } else {
      dispatch({ type: LOGIN_FAILED, payload: null });
      return response;
    }
  } catch (error) {
    dispatch({ type: LOGIN_FAILED, payload: null });
    return Promise.reject(error);
  }
};


export const loginAdmin = (data) => async (dispatch) => {
  try {
    const response = await AuthService.LoginAdmin(data);

    if (response?.isSuccess) {
      const user = {
        id: response?.data?.userID,
        firstName: response?.data?.firstName,
        lastName: response?.data?.lastName,
        email: response?.data?.email,
        role: response?.data?.userType,
        profileUrl: response?.data?.profileUrl,
      };
      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          access_token: response?.data?.tokens?.access_token,
          user: user,
        },
      });

      JWT.setJwt(response?.data?.tokens?.accessToken);
       JWT.setRefreshJwt(response?.data?.tokens?.refreshToken?.tokenString);
      AuthService.setLoginUser(user);

      return response;
    } else {
      dispatch({ type: LOGIN_FAILED, payload: null });
      return response;
    }
  } catch (error) {
    dispatch({ type: LOGIN_FAILED, payload: null });
    return Promise.reject(error);
  }
};

export const login2FA = (data) => async (dispatch) => {
  try {
    const response = await AuthService.Login2FA(data);

    if (response?.isSuccess) {
      return response;
    } else {
      dispatch({ type: LOGIN_FAILED, payload: null });
      return response;
    }
  } catch (error) {
    dispatch({ type: LOGIN_FAILED, payload: null });
    return Promise.reject(error);
  }
};

export const logout = () => (dispatch) => {
  JWT.removeJWT();
  AuthService.removeLoginUser();
  dispatch({ type: LOGOUT });
};
